// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"216":"874eaab5","615":"e9f79008","856":"1906aa2b"}[chunkId] + ".chunk.css";
};